import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import titleTemplate from 'lib/title-template';
import { NextPage } from 'next';
import Page from 'components/common/page';
import Head from 'next/head';
import {
  getSharingInvitation,
  acceptSharingInvitation,
} from 'models/citation-list-model';
import WithSession from 'lib/with-session';
import { useSelector, useStore } from 'react-redux';
import { Store, useAppDispatch } from 'redux/store';
import { getMe } from 'models/auth-model';
import { setUserData } from 'redux/modules/auth-module';
import { loadCitationList } from 'redux/modules/citation-list-module';
import Button from 'components/common/button';
import css from './[shareId].module.css';

const AccessShared: NextPage = () => {
  const router = useRouter();
  const shareId = router.query.shareId as string;
  const email = useSelector((store: Store) => store.auth.data?.email);
  const [invitation, setInvitation] = useState<{
    owner: string;
    listName: string;
  } | null>(null);
  const dispatch = useAppDispatch();
  const store = useStore();

  useEffect(() => {
    getSharingInvitation(shareId).then((res) => {
      const isOwner = email && res.data.owner === email;
      const isCollaborator = email && res.data.collaborators.includes(email);

      if (isOwner || isCollaborator) {
        dispatch(
          loadCitationList({
            listIDToLoad: res.data.id,
            store,
          }),
        );
        router.push('/');
        return;
      }

      setInvitation(res.data);
    });
  }, [shareId, email, router, dispatch, store]);

  return (
    <div>
      <Page pageName="Access Shared">
        <Head>
          <title>{titleTemplate('Access shared list')}</title>
        </Head>
        {invitation && (
          <div className={css.invitationWrapper}>
            <p className={css.joinInvitationText}>
              Join &quot;{invitation.listName}&quot;
            </p>
            <p>
              {invitation.owner} invited you to cooperate on the citation list
            </p>
            <Button
              onClick={async () => {
                await acceptSharingInvitation(shareId);
                const res = await getMe();
                dispatch(setUserData(res.data));
                router.push('/');
              }}
            >
              Accept invitation
            </Button>
          </div>
        )}
      </Page>
    </div>
  );
};

export default WithSession(AccessShared);
